import { render } from "./topics.vue?vue&type=template&id=2579da9c&scoped=true"
import script from "./topics.vue?vue&type=script&lang=js"
export * from "./topics.vue?vue&type=script&lang=js"

import "./topics.vue?vue&type=style&index=0&id=2579da9c&lang=scss"
import "./topics.vue?vue&type=style&index=1&id=2579da9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2579da9c"]])

export default __exports__